module.exports = __webpack_public_path__ + "static/media/email-logo_white.e51d4bc9.png";